import { common } from '../common.js';
import type { IProgram } from '../types.js';

/** Sponsoring parents and grandparents (by invitation only; new intake paused). */
export const PARENTS_GRANDPARENTS: IProgram = {
  id: 'parents-grandparents',
  name: 'Parents and grandparents sponsorship',
  short: 'Parents and grandparents',
  family: 'family',
  status: 'paused',
  pausedNote: 'IRCC isn\'t accepting new interest to sponsor forms or sending invitations (the 2025 intake closed October 9, 2025). Existing applications are still processed.',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC: Sponsor your parents and grandparents, how to apply', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/family-sponsorship/sponsor-parents-grandparents/apply.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'coSigner', text: 'Is there a co-signer (the sponsor\'s spouse or common-law partner)?', kind: 'yesno' },
    { id: 'commonLaw', text: 'Is the sponsor or the person sponsored in a common-law relationship?', kind: 'yesno' },
    { id: 'incomeSources', text: 'Is income from sources other than Notices of Assessment being used?', kind: 'yesno' }
  ],
  roles: [
    { id: 'sponsor', label: 'Sponsor', min: 1, max: 1 },
    { id: 'principal', label: 'Parent or grandparent (principal applicant)', min: 1, max: 1 },
    { id: 'dependant', label: 'Their spouse or dependant', min: 0, max: 10 }
  ],
  sections: ['Forms', 'Identity and civil documents', 'Photos and police certificates', 'Sponsor', 'Fees'],
  items: [
    { id: 'invitation', label: 'Invitation to apply (copy)', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm5771', label: 'Document Checklist, Sponsor', form: 'IMM 5771', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm1344', label: 'Application to Sponsor, Sponsorship Agreement and Undertaking', form: 'IMM 1344', section: 'Forms', forRoles: 'application', source: 0, hint: 'Signed digitally by the sponsor, any co-signer and the person sponsored.' },
    { id: 'imm5768', label: 'Financial Evaluation for Parents and Grandparents Sponsorship', form: 'IMM 5768', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm5748', label: 'Income Sources for the Sponsorship of Parents and Grandparents', form: 'IMM 5748', section: 'Forms', forRoles: 'application', when: { q: 'incomeSources', is: true }, source: 0 },
    { id: 'imm5409', label: 'Statutory Declaration of Common-Law Union (signed by hand)', form: 'IMM 5409', section: 'Forms', forRoles: 'application', when: { q: 'commonLaw', is: true }, source: 0 },
    { id: 'imm0008', label: 'Generic Application Form for Canada (online)', form: 'IMM 0008', section: 'Forms', forRoles: ['principal'], source: 0 },
    { id: 'imm5669', label: 'Schedule A, Background/Declaration (online)', form: 'IMM 5669', section: 'Forms', forRoles: ['principal', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5406', label: 'Additional Family Information (online)', form: 'IMM 5406', section: 'Forms', forRoles: ['principal', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5562', label: 'Supplementary Information, your travels (online)', form: 'IMM 5562', section: 'Forms', forRoles: ['principal', 'dependant'], minAge: 18, source: 0 },
    common.representative(0),
    common.passport(0, ['principal', 'dependant']),
    { id: 'birth', label: 'Proof of the relationship to the sponsor (birth certificates)', section: 'Identity and civil documents', forRoles: 'application', source: 0, translationIfNotEnFr: true },
    common.photos(0, ['principal', 'dependant']),
    common.police(0, ['principal', 'dependant']),
    { id: 'sponsorStatus', label: 'Proof of the sponsor\'s status in Canada', section: 'Sponsor', forRoles: ['sponsor'], source: 0 },
    { id: 'income', label: 'Proof of income for the required tax years (CRA Notices of Assessment, or as the checklist asks)', section: 'Sponsor', forRoles: ['sponsor'], source: 0 },
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};
